import {useState} from "react";
import useMerchantPortalAxios from "../utils/axios";

const useCommonAPI = () => {

    const CommonAxios = useMerchantPortalAxios();

    const [regions, setRegions] = useState([]);
    const [tillTypes, setTillTypes] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [roles, setRoles] = useState(null);

    const getAllRegions = async () => {
        await CommonAxios.get("/v1/CommonData/GetAllRegions")
            .then((res) => {
                setRegions(res.data.Regions);
            })
    }

    const getAllTillTypes = async () => {
        await CommonAxios.get("/v1/CommonData/GetAllTillTypes")
            .then((res) => {
                setTillTypes(res.data.TillTypes)
            })
    }

    const getAllCurrencies = async () => {
        await CommonAxios.get("/v1/CommonData/GetAllCurrencies")
            .then((res) => {
                setCurrencies(res.data.Currencies)
            })
    }

    const getAllEmployeesRoles = async () => {
        await CommonAxios.get("/v1/CommonData/GetAllEmployeesRoles")
            .then((res) => {
                setRoles(res.data.AllRoles)
            })
    }

    return {
        getAllRegions,
        getAllTillTypes,
        getAllCurrencies,
        getAllEmployeesRoles,
        regions,
        tillTypes,
        currencies,
        roles
    }
}

export default useCommonAPI;